import { useCallback, useMemo, useState } from "react";
import { useParticipants } from "@livekit/components-react";
import { PARTICIPANT_ROLES } from "@/react/helpers/liveStreamRoomHelpers";
import { SPECTATORS_PAGE_SIZE } from "../provider/constants";
import type { ProviderSpectators } from "../types";
import { convertParticipantToPeer } from "./helpers";

const loadPeers = () => Promise.resolve();

export const useLivekitSpectators = (): ProviderSpectators => {
  const [page, setPage] = useState(1);
  const participants = useParticipants();
  const spectators = useMemo(
    () =>
      participants
        .map(convertParticipantToPeer)
        .filter(
          participant =>
            !!participant.customerUserId &&
            participant.roleName === PARTICIPANT_ROLES.HLS_SPECTATOR,
        ),
    [participants],
  );
  const paginatedSpectators = useMemo(
    () => spectators.slice(0, page * SPECTATORS_PAGE_SIZE),
    [spectators, page],
  );

  const loadMorePeers = useCallback(() => {
    setPage(page => page + 1);
    return Promise.resolve();
  }, []);

  const hasNext = useCallback(
    () => page * SPECTATORS_PAGE_SIZE < spectators.length,
    [page, spectators.length],
  );

  return {
    peers: paginatedSpectators,
    loadPeers,
    loadMorePeers,
    hasNext,
    total: spectators.length,
  };
};
